export const GoogleAuthErrorType = {
  DomainMismatch: 'DomainMismatch',
  NoMerchantAccount: 'NoMerchantAccount',
  NotAdmin: 'NotAdmin',
};

export const GoogleAuthAbbreviatedErrorMessage = ({ i18n, storeDomain, gmcDomain }) => ({
  DomainMismatch: i18n.getString(_TL_('We are unable to import offers because the Microsoft Advertising domain URL {{storeDomain}} doesn’t match the website URL {{gmcDomain}} of the selected Google Merchant Center account. Select another Google Merchant Center account.'), { storeDomain, gmcDomain }),
  NotAdmin: i18n.getString(_TL_('The Google account is not an administrator to this Google Merchant Center account. Sign in again to a different Google account.')),
});

export const GoogleAuthErrorTypeConfigs = ({ i18n, storeDomain, info }) => [
  {
    type: GoogleAuthErrorType.DomainMismatch,
    title: i18n.getString(_TL_('Store domain mismatch')),
    text1: i18n.getString(_TL_('We are unable to import offers because the Microsoft Advertising store domain URL {{storeDomain}} doesn’t match the website URL {{info}} of the selected Google Merchant Center account.'), { storeDomain, info }),
    text2: i18n.getString(_TL_('Select another Google Merchant Center account that has a store website URL that matches the Microsoft Advertising store domain URL.')),
  },
  {
    type: GoogleAuthErrorType.NoMerchantAccount,
    title: i18n.getString(_TL_('Google account error')),
    text1: i18n.getString(_TL_('We couldn\'t find a Google Merchant Center account that uses this Google account {{info}}.'), { info }),
    text2: i18n.getString(_TL_('Please sign in again to a different Google account.')),
  },
  {
    type: GoogleAuthErrorType.NotAdmin,
    title: i18n.getString(_TL_('The following user is not a Google Merchant Center administrator: {{info}}'), { info }),
    text1: i18n.getString(_TL_('To access the Google Merchant Center store details to initiate the import, you must be an administrator for the account.')),
    text2: i18n.getString(_TL_('Please sign in to a Google account with administrator access.')),
  },
];
